export default "__VITE_ASSET__CHyw0WDL__"